"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagForAll = void 0;
var isTagForAll = function (tag) { return tag.FR.startsWith('Tous'); };
exports.isTagForAll = isTagForAll;
//# sourceMappingURL=tags.js.map